var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6583592,1.56524755 C11.0288432,0.824279825 11.9298527,0.523943326 12.6708204,0.894427195 C12.9611115,1.03957275 13.1964952,1.27495648 13.3416408,1.56524758 L23.7236068,22.3291796 C24.0940907,23.0701473 23.7937542,23.9711568 23.0527864,24.3416408 C22.8445033,24.4457824 22.6148336,24.5 22.381966,24.5 L1.61803399,24.5 C0.789606878,24.5 0.118033989,23.8284271 0.118033989,23 C0.118033989,22.8137059 0.152733282,22.6294585 0.219933482,22.4565703 L0.276393224,22.3291796 L10.6583592,1.56524755 Z M1.14170664,22.8479726 C1.12606623,22.896977 1.11803399,22.9482516 1.11803399,23 C1.11803399,23.2761423 1.34189164,23.5 1.61803399,23.5 L22.381966,23.5 C22.4595885,23.5 22.5361451,23.4819274 22.6055728,23.4472136 C22.8525621,23.3237189 22.9526743,23.0233824 22.8291796,22.7763932 L12.4472136,2.01246118 C12.3988318,1.91569749 12.3203705,1.83723624 12.2236068,1.78885439 C11.9766175,1.66535976 11.676281,1.76547193 11.5527864,2.01246118 L1.17082039,22.7763932 L1.14170664,22.8479726 Z",
    id: "Path-2",
    fill: "#EB8C07",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.70d1e708a4b5d61d003c2a901ee47584.svg";
export { ForwardRef as ReactComponent };